import { createJSONStorage, type StateStorage } from 'zustand/middleware'

import { storageService } from './storage-service'

/**
 * Zustand `persist` storage that routes through `StorageService` instead of
 * touching `localStorage` directly.
 */
const driver: StateStorage = {
  getItem: (name) => storageService.getRaw(name),
  setItem: (name, value) => {
    storageService.setRaw(name, value)
  },
  removeItem: (name) => {
    storageService.remove(name)
  },
}

export const zustandStorage = createJSONStorage(() => driver)
